<template>
  <div id="mid">
    <div class="block-left">
      <buttons v-if="showButtons" @view-select="viewChanged" />
    </div>
    <div class="block-right">
      <div class="tab">
        <img :src="Tab" role="presentation">
      </div>
      <div class="stripe" />
      <div class="menu">
        <img :src="Tracinhos" role="presentation">
      </div>
      <div class="clickArea" @click="openAbout" />
    </div>
  </div>
</template>

<script>
  import Buttons from './buttons';
  import Tab from 'Assets/images/tab.svg';
  import Tracinhos from 'Assets/images/tracinhos.png';
  import EventSystem from '../utils/EventSystem';

  export default {
    components: { Buttons },
    props: {},
    data() {
      return {
        Tab,
        Tracinhos,
        showButtons: false,
      };
    },
    created() {
      EventSystem.$on('area-changed', area => {
        this.showButtons = area !== 'Todas';
      });
      EventSystem.$on('front-changed', () => {
        this.showButtons = false;
      });
    },
    computed: {},
    methods: {
      openAbout() {
        EventSystem.$emit('about-open');
      },
      viewChanged(n) {
        EventSystem.$emit('view-change', n);
      },
    },
  }
</script>



// WEBPACK FOOTER //
// assets/js/source/vue-ui/mid.vue